import { FormattedMessage } from "react-intl";

export default function UploadProgress({ progress }: { progress: number }) {
  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="min-w-24">
        <FormattedMessage id="actions.uploadProgress" />
      </span>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full bg-primary transition-[width]"
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="min-w-12 text-right">{progress}%</span>
    </div>
  );
}
